import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ROUTE } from '@lib/core/const';
import { EnvironmentService } from '@lib/core/environment';
import { ActivatedRouteHelper } from '@lib/core/helper';
import { Uuid } from '@lib/core/type';
import { LogRepository as DefaultRepository, LogListItem, LogDiff } from '@lib/log';
import { QueryParams } from '@proget-shared';
import { AuthHttpClient } from '@proget-shared/auth-http-client';
import { PagingList } from '@proget-shared/grid/grid-control';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserLogRepository implements DefaultRepository {
  private readonly httpClient = inject(AuthHttpClient);
  private readonly environment = inject(EnvironmentService);
  private readonly activatedRoute = inject(ActivatedRoute);

  public getLogActions(): Observable<string[]> {
    const userId = ActivatedRouteHelper.readAllData(this.activatedRoute).user?.uuid;

    return this.httpClient.get<string[]>(`${this.environment.apiUrl}/user/${userId}/audit-logs/actions`);
  }

  public getLogs(params: QueryParams): Observable<PagingList<LogListItem>> {
    const userId = ActivatedRouteHelper.readAllData(this.activatedRoute).user?.uuid;

    return this.httpClient.get<any>(`${this.environment.apiUrl}/user/${userId}/audit-logs`, { params })
      .pipe(
        map((data) => new PagingList<LogListItem>(
          data.items,
          data.limit,
          data.offset,
          data.total
        )));
  }

  public getLog(uuid: Uuid): Observable<any> {
    return this.httpClient.get<any>(`${this.environment.apiUrl}/audit-logs/${uuid}`);
  }

  public getLogDiff(uuid: Uuid): Observable<LogDiff> {
    return this.getLog(uuid)
      .pipe(
        map((data) => ({
          previous: data?.extras?.objectChanges?.previousObjectData ?? {},
          current: data?.extras?.objectChanges?.currentObjectData ?? {},
        }))
      );
  }

  public getLogTraceRoute(): string[] {
    return [ROUTE.BASE, ROUTE.LOG.BASE];
  }
}
